import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import { useNavigation } from 'react-router';

export const NavigationProgress: React.FC = () => {
  const { state } = useNavigation();

  if (state === 'idle') {
    return null;
  }

  return <LinearProgress sx={{ left: 0, position: 'fixed', right: 0, top: 0, zIndex: 1400 }} />;
};
